import { render, staticRenderFns } from "./HeaderExpense.vue?vue&type=template&id=799e358a&"
import script from "./HeaderExpense.vue?vue&type=script&lang=js&"
export * from "./HeaderExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports